import { Temporal } from '@js-temporal/polyfill'
import {
  Calendar,
  CalendarIcon,
  Flex,
  IconButton,
  Popover,
  Text,
  WarningIcon,
} from '@buffer-mono/popcorn'
import styles from './CreatorCamp.module.css'

// TODO: creator-camp-cleanup
export const CreatorCampInternalCalendar = ({
  todayDate,
  setCreatorCampTodayDate,
}: {
  todayDate: Temporal.PlainDate | undefined
  setCreatorCampTodayDate: (date: Temporal.PlainDate | undefined) => void
}): JSX.Element => {
  const creatorCampCalendarStart = Temporal.PlainDate.from('2025-06-16')
  const creatorCampCalendarEnd = Temporal.PlainDate.from('2025-07-15')
  return (
    <Flex align="center" gap="xs" className={styles.internalCalendar}>
      <WarningIcon size="small" color="brand" />
      <Text size="sm" color="brand" weight="bold">
        Only visible internally:{' '}
      </Text>
      <Text size="sm" color="brand">
        Set the &quot;today&quot; date to test Creator Camp features
      </Text>
      <Popover>
        <Popover.Trigger>
          <IconButton
            label="Set Creator Camp Date"
            size="small"
            variant="tertiary"
          >
            <CalendarIcon color="brand" />
          </IconButton>
        </Popover.Trigger>
        <Popover.Content>
          <Calendar
            value={todayDate}
            onValueChange={setCreatorCampTodayDate}
            min={creatorCampCalendarStart}
            max={creatorCampCalendarEnd}
          />
        </Popover.Content>
      </Popover>
    </Flex>
  )
}
